module.exports = __webpack_public_path__ + "static/media/TitlePage_1.e04388fc.gif";